<template>
    <div class="modal-content">
        <div class="content">
                <div class="once-column"  v-if="scoreDetail.length > 1">
                    <div class="empty"></div>
                    <div  class="race-name" v-for="(round,index) in scoreDetail" :key="index">ROUND {{round.round}}（{{round.redScore}}:{{round.blueScore}}）</div>
                </div>
                <div class="coach">
                    <div class="column-name">
                        <div class="name-cell" v-for="(roundName,i) in scoreDetail[0].roundScores" :key="i">{{roundName.fromRefee}}</div>
                    </div>      
                    <div class="column" v-for="(roundScores,row) in scoreDetail" :key="row">
                        <div class="column-cell" @click="handleScoreDetail(roundScores,j)" :class="roundScore.winSide==0?'cell-red':'cell-blue'" v-for="(roundScore,j) in roundScores.roundScores" :key="j">{{roundScore.score?roundScore.score:''}}</div>
                    </div>
                </div>
          </div>
        <div class="explain">点击色块查看分数详情</div>
    </div>
</template>

<script>
export default {
  name:'StreeModalContent',
  props:['scoreDetail','allData'],
  data () {
    return {
    }

  },
  computed: {
    name () {
      return this.data 
    }
  },
  mounted () {
  },
  methods: {
    handleScoreDetail (roundScores,i) {
      // 详情请求接口参数封装
      let scoreDetailData={}
      scoreDetailData.round=roundScores.round
      scoreDetailData.fromRefee=roundScores.roundScores[i].fromRefee
      scoreDetailData.pkId=this.allData.pkId
      scoreDetailData.scoreModle=this.allData.scoreModle
      //分数不为空切换详情组件
      if(roundScores.roundScores[i].score){
        scoreDetailData.isDetail=true
        this.$emit('handleChangeDetail',scoreDetailData)
      }else{
        this.$message.warning('暂无分数')
      }
    }
      
  },
}
</script>

<style lang="scss" scoped>
.modal-content{
    .content{
        width: 1100px;
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        .once-column{
            width: 120px;
            .race-name{
                width: 120px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                font-weight: bold;
                color: #333333;
                margin-top: 10px;
            }
            .empty{
                width: 120px;
                height: 80px;
                line-height: 80px;
                margin-top: 0;
            }
        }
        //教练
        .coach{
            display: flex;
            width: 100%;
            flex-direction: column;
            // justify-content: space-evenly;
            .column-name{
                text-align: center;
                font-weight: bold;
                color: #333333;
                line-height: 80px;
                height: 80px;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                .name-cell{
                      width: 100%;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    margin-top: 10px;
                    font-weight: bold;
                    font-size: 16px;
                }
            }
            .column{
                width: 100%;
                display: flex;
                justify-content: space-evenly;
                .column-cell{
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    margin-right: 10px;
                    margin-top: 10px;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: 16px;
                    cursor: pointer;
                }
                .cell-blue{
                    background-color: #2364B9;
                }
                .cell-red{
                    background-color: #D53F48;
                }
            }
            

        }   
        
    }
.explain{
        width: 1100px;
        height: 100px;
        line-height: 100px;
        font-size: 14px;
        color: #888888;
        font-weight: Medium;
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/stree/StreeModalContent.vue